var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerify(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8.38 12l2.41 2.42 4.83-4.84",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M10.75 2.45a2.02 2.02 0 0 1 2.52 0l1.58 1.36a2.22 2.22 0 0 0 1.26.47h1.7a1.94 1.94 0 0 1 1.93 1.93v1.7c0 .39.21.96.47 1.26l1.36 1.58a2.02 2.02 0 0 1 0 2.52l-1.36 1.58a2.22 2.22 0 0 0-.47 1.26v1.7a1.94 1.94 0 0 1-1.93 1.93h-1.7c-.39 0-.96.21-1.26.47l-1.58 1.36a2.02 2.02 0 0 1-2.52 0l-1.58-1.36a2.22 2.22 0 0 0-1.26-.47H6.18a1.94 1.94 0 0 1-1.93-1.93V16.1a2.28 2.28 0 0 0-.46-1.25l-1.35-1.59c-.58-.69-.58-1.81 0-2.5l1.35-1.59a2.28 2.28 0 0 0 .46-1.25V6.2a1.94 1.94 0 0 1 1.93-1.93h1.73c.39 0 .96-.21 1.26-.47l1.58-1.35z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify);
export default __webpack_public_path__ + "static/media/verify.4e6b89526aa6a4c1a916bcab6cbe0558.svg";
export { ForwardRef as ReactComponent };